/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed May 11 2022
*  File : AbstractModuleAutoloadManager.ts
*******************************************/



import { ConfigHelper } from '../config/ConfigHelper.js';
import { PropertyConfig } from '../config/PropertyConfig.js';
import { SdkGuiController } from "../gui/guiControllers/SdkGuiController.js";
import { PushServiceInterface } from "../subscriptions/PushServiceInterface.js";
import { SdkModuleAutoloadManager } from "./SdkModuleAutoloadManager.js";

export abstract class AbstractModuleAutoloadManager implements SdkModuleAutoloadManager {
    private sdkGui: Promise<SdkGuiController> = null;
    private sdkClient: Promise<any> = null;

    private sdkServerPromise: Promise<void> = null;
    
    private pushService: Promise<PushServiceInterface> = null;

    
    
    
    protected readonly configHelper: ConfigHelper;


    
    constructor(
        protected readonly win: WindowProxy,
        config: PropertyConfig
    ) {
        this.configHelper = new ConfigHelper(config);
    }

    protected abstract initGui(): Promise<SdkGuiController>;
    protected abstract initSdkClient(): Promise<any>;
    protected abstract initSdkServer(): Promise<any>;
    protected abstract initPushHelper(): Promise<PushServiceInterface>;
    

   


    


    public getGui(): Promise<SdkGuiController> {
        if (this.sdkGui === null) {
            this.sdkGui = this.initGui();
        }
        return this.sdkGui;
    }
    public guiLoaded(): boolean {
        return this.sdkGui != null;
    }
    
    public startSdk() : Promise<any> {
        return Promise.all([
            this.startSdkClient(),
            this.startSdkServer()
        ]).then(
            v => v[0]
        );
    }

    public getSdkClient(): Promise<any> {
        return this.startSdkClient();
    }

    public startSdkClient(): Promise<any> {
        if (this.sdkClient === null) {
            this.sdkClient = this.initSdkClient();
        }
        return this.sdkClient;
    }
    
    public startSdkServer(): Promise<void> {
        if (this.sdkServerPromise === null) {
            this.sdkServerPromise = this.initSdkServer();
        }
        return this.sdkServerPromise;
    }
    public getPushHelper(): Promise<PushServiceInterface> {
        if (this.pushService === null) {
            this.pushService = this.initPushHelper();
        }
        return this.pushService;
    }

 
    

    /**
     * Carica uno script in pagina. 
     * @param src Url per caricare lo script
     * @param id id da associare allo script per evitare duplicazioni
     * @returns Restituisce una promise che si risolve al carcamento dello script (indipendentemente da operazioni che esegue)
     */
    protected injectScript(src: string, id: string) : Promise<void> {
        const existing = document.getElementById(id);
        if (existing) {
            // ? Questo è impreciso, l'esistenza dello script non implica che sia stato caricato
            // ? questo caso andrebbe aggironato per far emettere la promise solo se lo script è caricato
            return Promise.resolve();
        }
        else {
            return new Promise((resolve, reject) => {
                const first = document.getElementsByTagName('script')[0];
        
                const ele = document.createElement('script');
                ele.type = "text/javascript";
                ele.id = id;
                ele.src = src;
                ele.onerror = function(err) {
                    reject(err);
                };
                ele.onload = () => {
                    resolve();
                };
        
                if (first) {
                    first.parentNode.insertBefore(ele, first);
                }
                else {
                    document.head.appendChild(ele);
                }
    
            });
        }

    }

}